(function(){
  var country = window.MSK_COUNTRY || '';
  if (country !== 'DE') return;

  var LANG_KEY = 'msk_lang';
  var saved = localStorage.getItem(LANG_KEY);
  if (saved) return; // respect user's manual choice

  function setDe() {
    if (typeof mskSetLang === 'function') { mskSetLang('de'); }
    else { setTimeout(setDe, 50); }
  }
  setDe();

  // Photo reviews data (German text, German cities)
  var photoReviews = [
    {t:'"In einwandfreiem Zustand erhalten! Sehr gut verpackt mit der MySportKits-Karte. 100% empfohlen!"', n:'Lukas M. \u2014 Berlin'},
    {t:'"Die TNs sind super, perfekte Gr\u00f6\u00dfe. Das Warten war es wert."', n:'Sophie K. \u2014 M\u00fcnchen'},
    {t:'"Topqualit\u00e4t f\u00fcr den Preis! Genau wie auf den Fotos. Sehr zufrieden."', n:'Jonas H. \u2014 Hamburg'},
    {t:'"Wundersch\u00f6n! Perfekte Gr\u00f6\u00dfe, sorgf\u00e4ltige Verpackung mit Dankeskarte."', n:'Emma W. \u2014 Frankfurt'},
    {t:'"Gr\u00f6\u00dfe 42, super bequem. Farbe genau wie erwartet."', n:'Felix B. \u2014 K\u00f6ln'},
    {t:'"F\u00fcr meine Tochter (36) bestellt, sie ist begeistert! Makellose Sneaker."', n:'Laura S. \u2014 Stuttgart'},
    {t:'"Schwarze/gelbe TNs in toller Qualit\u00e4t. Zuverl\u00e4ssiger Shop, schon meine 3. Bestellung!"', n:'Tim R. \u2014 D\u00fcsseldorf'},
    {t:'"2. Kauf bei MySportKits, immer top! Wundersch\u00f6ne wei\u00dfe Schuhe."', n:'Lena F. \u2014 Leipzig'},
    {t:'"In ausgezeichnetem Zustand erhalten. Mein Nachbar hat nach meinem auch bestellt!"', n:'Max N. \u2014 Dresden'}
  ];

  // Update photo-rv-tag, photo-rv-title, all badges
  function fixPhotoTexts() {
    var pt = document.getElementById('photo-rv-tag');
    if (pt) pt.textContent = '\ud83d\udcf8 Verifizierte Bewertungen mit Fotos';
    var ph = document.getElementById('photo-rv-title');
    if (ph) ph.textContent = 'SIE HABEN IHRE BESTELLUNG ERHALTEN';
    document.querySelectorAll('.rv-badge').forEach(function(el) {
      el.textContent = '\u2713 Verifiziert';
    });
  }

  // Update photo review card text, name, badge
  function fixPhotoGrid() {
    fixPhotoTexts();
    var grid = document.getElementById('photo-reviews-grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.rv-card');
    cards.forEach(function(card, i) {
      var pr = photoReviews[i % photoReviews.length];
      var textEl = card.querySelector('.rv-text');
      var nameEl = card.querySelector('.rv-name');
      var badgeEl = card.querySelector('.rv-badge');
      if (textEl) textEl.textContent = pr.t;
      if (nameEl) nameEl.textContent = pr.n;
      if (badgeEl) badgeEl.textContent = '\u2713 Verifiziert';
    });
  }

  function run() {
    fixPhotoGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 500);
  setTimeout(run, 1000);
})();
